<template>
    <div class="dynamic-phone-container">
        <v-row dense>
            <v-col cols="12" sm="6">
                <PhoneField :value="phone" :label="label" @input="updatePhone" v-bind="$attrs" class="dynamic-phone-field">
                    <template #label><slot name="label">{{$attrs.label}}</slot></template>
                    <template #message="messageProps">
                        <slot name="message" :message="messageProps.message" />
                    </template>
                </PhoneField>
            </v-col>
            <v-col cols="12" sm="6">
                <RadioField
                    class="dynamic-phone-radio"
                    :value="value"
                    @input="updatePhoneType"
                    :options="phoneTypes"
                    name-field="label"
                    sort-by="-label"
                    required
                    row
                    :radio-attrs="radioAttrs"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
            },

            homePhone: {
                type: String,
            },

            mobilePhone: {
                type: String,
            },

            value: {
                type: String,
            },

            phoneTypes: {
                type: Array,
                required: true,
            },
            radioAttrs: {
                type: Object,
                default: () => {
                    return {}
                },
            },
        },

        computed: {
            computedPhoneType() {
                return this.value || "mobile"
            },

            phone() {
                if (this.computedPhoneType === "home") {
                    return this.homePhone
                } else {
                    return this.mobilePhone
                }
            },
        },

        methods: {
            updatePhoneType(type) {
                this.$emit("input", { phone: this.phone, type })
            },

            updatePhone(phone) {
                this.$emit("input", { phone, type: this.computedPhoneType })
            },
        },
    }
</script>

<style lang="scss" scoped>
    @media screen and (max-width: 992px){
        .dynamic-phone-radio {
            margin-top: -10px !important;;
            margin-bottom: 0 !important;

            &::v-deep .v-input__slot {
                margin-bottom: 0;
            }
        }
    }
</style>
